export default __webpack_public_path__ + "static/media/pw-template-units.738eb41b.jpg";